import React, { createContext, useContext, useMemo } from "react";

const ItemListContext = createContext({
  item_list_id: undefined,
  item_list_name: undefined,
});

export function ItemListProvider({ item_list_id, item_list_name, children }) {
  const value = useMemo(
    () => ({
      item_list_id: item_list_id || undefined,
      item_list_name: item_list_name || undefined,
    }),
    [item_list_id, item_list_name]
  );
  return (
    <ItemListContext.Provider value={value}>{children}</ItemListContext.Provider>
  );
}

export function useItemListContext() {
  return useContext(ItemListContext);
}
